import { Tab, useTheme } from "@mui/material"
import { StyledSubTabs } from "./navigation/AppBar/AppBar.styled"

const ThemedSubTabs = ({ tabs, value, setValue, marginLeft = "0" }) => {
  const theme = useTheme()

  const handleChange = (_, newValue) => {
    setValue(newValue)
  }

  return (
    <div style={{ width: "100%", marginLeft }}>
      <StyledSubTabs value={value} onChange={handleChange} variant={"scrollable"}>
        {tabs &&
          tabs.map((item, index) => {
            return (
              <Tab
                sx={{
                  color: theme.palette.default[500]
                }}
                id={`tab-${index}`}
                label={item.label}
                key={index}
              />
            )
          })}
      </StyledSubTabs>
    </div>
  )
}

export default ThemedSubTabs
